import React, { useState } from 'react';
import { Button, Checkbox, Form, Input, Card, Flex, Typography } from 'antd';
import { Link } from 'react-router-dom';
import { FormProps } from 'antd/lib/form';
import {
  login,
  getUserRole,
  logEvent,
} from '../../services/ApiActions/authAct';
import Toast from '../../services/ToastMessage';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { forgetPassword } from '../../services/ApiActions/authAct';
import Logo from '../../components/Header/Logo';
import PageHeading from '../../components/Layout/PageHeading';
import './login.styles.scss';
const { Title, Text } = Typography;
type FieldType = {
  username?: string;
  password?: string;
  placeholder?: string;
  //remember?: boolean; // Change the type of remember field to boolean
};
interface CustomError {
  data: any;
  error: any;
}

const LoginPage: React.FC = () => {
  const [isProcesssing, setIsProcesssing] = useState(false);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const onFinish: FormProps<FieldType>['onFinish'] = async (values) => {
    const { username, password } = values;
    setIsProcesssing(true);
    try {
      const res = (await login({
        identifier: username,
        password: password,
      })) as any;
      const { user } = res;

      localStorage.setItem('isLoggedIn', 'true');
      localStorage.setItem('user', JSON.stringify(user));
      logEvent({ event_type: 'login' });
      const response: any = await getUserRole();
      const userRole = response.data.role.type;
      console.log('API Response (userRole):', userRole);

      localStorage.setItem('userRole', userRole || '');

      // Handle post-login redirect
      const redirectUrl = searchParams.get('redirect');
      if (redirectUrl) {
        navigate(redirectUrl, { replace: true });
        return;
      }

      if (userRole === 'admin') {
        navigate('/admin');
      } else if (user?.email === 'pooja.shah@equentis.com' || user?.email === 'aatish.shah@equentis.com' || user?.email === 'manish.singh@equentis.com') {
        navigate('/dashboard');
      } else {
        navigate('/lms-consumption-dashboard');
      }
      // } else {
      //   navigate('/ask-me-anything');
      // }
    } catch (e) {
      let errorMessage = 'Something went wrong';
      if (e?.error?.name === 'ValidationError') {
        errorMessage = 'Invalid username or password';
      } else if (e?.error?.message) {
        errorMessage = e.error.message;
      }

      Toast({
        type: 'error',
        message: errorMessage,
      });
    } finally {
      setIsProcesssing(false);
    }
  };

  const onFinishFailed: FormProps<FieldType>['onFinishFailed'] = (
    errorInfo
  ) => {
    console.log('Failed:', errorInfo);
  };
  //remember: true
  return (
    <div className="login-bg" style={{ minHeight: '100vh' }}>
      <div className="login-overlay" style={{ minHeight: '100vh' }}>
        <div style={{ padding: '20px 24px' }}>
          <div>
            <Logo />
            <div
              style={{
                width: '400px',
                paddingTop: '6rem',
                marginLeft: 'auto',
                marginRight: 'auto',
              }}
            >
              <Card>
                <div style={{ marginBottom: '15px' }}>
                  <Flex gap="small" align="end" style={{ margin: '0' }}>
                    <Flex style={{ flexGrow: 1 }} align="baseline">
                      <Title
                        level={3}
                        className="heading"
                        style={{ margin: '0', fontSize: '24px' }}
                      >
                        Welcome Back!
                      </Title>
                      <img
                        className="sparkle"
                        src="/images/icons/sparkles.svg"
                        style={{ top: '-8px' }}
                      />
                    </Flex>
                  </Flex>
                  <Text type="secondary">Please enter your details</Text>
                </div>
                <Form
                  name="basic"
                  layout="vertical"
                  initialValues={{}}
                  onFinish={onFinish}
                  //onFinishFailed={onFinishFailed}
                  autoComplete="off"
                >
                  <Form.Item
                    label="Email"
                    name="username"
                    rules={[
                      {
                        required: true,
                        message: 'Please input your email ID!',
                      },
                    ]}
                  >
                    <Input placeholder="Enter Your Email ID" />
                  </Form.Item>

                  <Form.Item
                    label="Password"
                    name="password"
                    rules={[
                      {
                        required: true,
                        message: 'Please input your password!',
                      },
                    ]}
                  >
                    <Input.Password placeholder="Enter Your Password" />
                  </Form.Item>

                  <Form.Item style={{ marginBottom: 0 }}>
                    <Flex align="flex-end" justify="flex-end">
                      {
                        //<div style={{flexGrow: '1'}}>&nbsp;</div>
                        /*<Link to={'/forgot-password'} style={{flexGrow: '1'}}>
                  Forgot password?
                  </Link>*/
                      }
                      <Button
                        loading={isProcesssing}
                        type="primary"
                        htmlType="submit"
                        style={{
                          width: '100%',
                          marginTop: '16px',
                          border: 'none',
                          boxShadow: 'none',
                        }}
                      >
                        Login
                      </Button>
                    </Flex>
                  </Form.Item>
                </Form>
              </Card>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
